export default "__VITE_ASSET__aQNo4XGO__"